import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

//actions
import {
  getTermsAndConditions,
  updateTermsAndConditions,
} from '../../actions/users/manageTermsAndConditions';

//selectos
import { getTermsAndConditionsData } from '../../selectors/users';

const TermsAndConditions = (props) => {
  const navigate = useNavigate();
  const { handleSubmit } = useForm();
  const termsAndConditionsData = useSelector(getTermsAndConditionsData);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTermsAndConditions());
  }, []);

  const onSubmit = () => {
    dispatch(updateTermsAndConditions(termsAndConditionsData?.id_terminos)).then((response) => {
      if (response?.payload?.resultado === 'ok') {
        navigate('/');
      }
    });
  };

  return (
    <>
      <Col className='col-12 mb-4'>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className='mb-3'>
            <Form.Control
              as='textarea'
              rows={12}
              value={termsAndConditionsData?.texto ?? ''}
              readOnly
            />
          </Form.Group>
          <Col style={{ flexDirection: 'row-reverse', display: 'flex' }}>
            <Button type='submit' className={`btn btn-danger p-2`}>
              Aceptar los términos y condiciones
            </Button>
          </Col>
        </Form>
      </Col>
    </>
  );
};

export default TermsAndConditions;
